import {
  useTranslate,
  IResourceComponentsProps,
  useShow,
} from "@pankod/refine-core";
import { Show, Typography } from "@pankod/refine-antd";

import { IEventType } from "interfaces";

const { Title, Text } = Typography;

export const EventTypeShow: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();

  const { queryResult } = useShow<IEventType>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>{t("event_type.fields.name")}</Title>
      <Text>{record?.name}</Text>
    </Show>
  );
};
